<div
  class="card card-step"
  [ngClass]="{
    'is-selected': dataSourceControl.value === isfEntity.id,
    'is-desktop': isDesktop
  }"
  (focusin)="areaClicked.emit()"
>
  <div class="card-header" *ngIf="!isDesktop">
    <app-radio-button
      [control]="dataSourceControl"
      [id]="'dataSource-' + isfEntity.id"
      [label]="label"
      [value]="isfEntity.id"
      [classGroup]="'not-mb'"
    ></app-radio-button>
  </div>
  <div class="card-body" *ngIf="dataSourceControl.value === isfEntity.id || isDesktop">
    <div class="container" [formGroup]>
      <div class="form-row" *ngIf="showIdentifier">
        <div class="col-12">
          <div class="form-row">
            <div class="col-12">
              <div class="form-group mb-05">
                <div class="d-flex justify-content-between">
                  <label>
                    {{ "LABELS.BUSINESS_ID_NUMBER" | translate }}
                  </label>
                  <!--                  <a href class="clear-qual" *ngIf="!isDesktop" (click)="clearQualifier($event)">
                    {{ "FORM_LABEL.CLEAR_ID_INFO" | translate }}
                  </a>-->
                </div>
                <div class="btn-group" id="entityIdentifierQualifier">
                  <ng-container *ngFor="let qual of entityIdentifierQualifiers; let i = index">
                    <button
                      type="button"
                      class="btn btn-primary"
                      (click)="setIdentitiesQual(qual)"
                      [ngClass]="{ active: formGroup.get('entityIdentifierQualifier').value === qual }"
                    >
                      {{ qual | identifierQualifier | translate }}
                    </button>
                  </ng-container>
                </div>
                <app-control-errors
                  [control]="formGroup.get('entityIdentifierQualifier')"
                  [errors]="errors.entityIdentifierQualifier"
                  [isShowHelper]="false"
                ></app-control-errors>
              </div>
            </div>

            <div class="col-12" [ngClass]="{ 'col-md-8': showDateOfBirth }">
              <!-- identifier -->
              <app-control-wrapper
                [control]="formGroup.get('entityIdentifier')"
                [errors]="errors.entityIdentifier"
                [helper]="helperIdentifier"
              >
                <label control-label for="entityIdentifier">{{ entityIdentifierLabel | translate }}</label>

                <app-search-wrapper
                  [items]="identifierSearchResult"
                  [loading]="identifierLoading"
                  (callback)="changeAddress($event)"
                  control-wrapper
                >
                  <input
                    type="text"
                    [formControl]="formGroup.get('entityIdentifier')"
                    class="form-control"
                    id="entityIdentifier"
                    name="entityIdentifier"
                    [attr.inputmode]="identifierItemMask?.inputmode"
                    [placeholder]="identifierItemMask?.placeholder || ''"
                    [mask]="identifierItemMask?.mask"
                    [appMaskErrorTooltip]="identifierItemMask?.maskErrorTooltip"
                    [maxMaskLength]="identifierItemMask?.maskMaxLength"
                    #identifierInputElement
                  />
                </app-search-wrapper>
              </app-control-wrapper>
            </div>

            <div class="col-12 col-md-4" *ngIf="showDateOfBirth">
              <!-- date of birth control -->

              <date-picker
                [fc]="formGroup.get('dateOfBirth')"
                [errors]="errors.dateOfBirth"
                [id]="'dateOfBirth'"
                [name]="'dateOfBirth'"
                [label]="'LABELS.DATE_OF_BIRTH'"
                [placeholder]="'FORM_PLACEHOLDER.DATEOFBIRTH'"
              ></date-picker>
            </div>
          </div>
        </div>
      </div>

      <!-- name -->
      <app-control-wrapper
        [control]="formGroup.get('name')"
        [errors]="errors.name"
        [helper]="isDesktop ? '' : 'FORM_LABEL.AS_IN_COMMERCIAL_INVOICE'"
      >
        <label for="name" control-label>{{ "LABELS.NAME" | translate }}</label>
        <app-search-wrapper control-wrapper [items]="isfEntities" [loading]="companyLoading" (callback)="changeAddress($event)">
          <input
            type="text"
            [formControl]="formGroup.get('name')"
            class="form-control"
            id="name"
            name="name"
            [dropSpecialCharacters]="false"
            [patterns]="CUSTOM_MASK"
            [mask]="'F*'"
            [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
            #nameInputElement
          />
        </app-search-wrapper>
      </app-control-wrapper>
      <!-- address -->
      <ng-container *ngIf="isShowAddress">
        <address-update
          [formGroup]="formGroup"
          [code]="isfEntity.entityCode"
          [errors]="errors"
          [isShowState]="isShowState"
          [isShowCountry]="isForeignImporter || isConsigneeEntity"
          [isDesktop]="isDesktop"
          [defaultCountry]="isForeignImporter ? null : defaultCountry"
          [isFilterRestrictedCountries]="isfEntity.entityCode === enumEntityModelCode.IMPORTER"
        ></address-update>
      </ng-container>
    </div>

    <button type="button" class="btn btn-link btn-remove" *ngIf="isDesktop" (click)="resetForm()">
      <i class="fa fa-trash"></i>
      {{ "FORM_LABEL.CLEAR_FORM" | translate }}
    </button>
  </div>
</div>
